import styled from 'styled-components';
import PageTitle from '../components/pageTitle';
import greenWave from '../images/green_wave.png';

const EmailLink = styled.a`
  text-decoration: none;
  &:link { color: var(--black); }
  &:visited { color: var(--dark-green); }
  &:link:active, :visited:active { var(--dark-blue); }
  &:hover {
    color: var(--dark-blue);
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 18px;
  line-height: 1.5;

  @media (max-width: 800px) {
    width: 96%;
    max-width: 590px;
    margin: 0 auto;
    font-size: 16px;
  }
`;

const TitleWave = styled.img`
  width: 380px;
  pointer-events: none;

  @media (max-width: 800px) {
    width: 300px;
  }
`;

export default function Privacy() {
  return (
    <>
      <PageTitle>
        Polityka prywatności
        <TitleWave src={greenWave} />
      </PageTitle>
      <Section>
        <p>
          Dokładamy wszelkich starań, aby zdjęcia, w tym wizerunki, umieszczane
          na stronie internetowej i w social mediach
          Duszpasterstwa/wspólnoty/parafii przetwarzane były zgodnie z prawem
          powszechnie obowiązującym, w tym z prawem autorskim i regulacjami
          dotyczącymi ochrony danych osobowych, a także zgodnie z prawem
          kanonicznym. W przypadku zauważenia nieprawidłowości w tym
          przedmiocie, prosimy o kontakt z Inspektorem Ochrony Danych Osobowych
          wyznaczonym przez Klasztor:&nbsp;
          <EmailLink href="mailto:odo.sluzew@dominikanie.pl">
            odo.sluzew@dominikanie.pl
          </EmailLink>
          .
        </p>
      </Section>
    </>
  );
}
